import { createStore } from 'vuex'
import { Cookie } from '@/utils/request';

function getUser() {
    const userCookie = Cookie.get('user');
    if (!userCookie) return {
        role: { key: -1, },
    };
    return JSON.parse(userCookie);
}

export default createStore({
    state: {
        user: getUser(),
        modalData: {
            showModal: false,
            messages: [{
                'title': 'title',
                'message': 'message',
            }],
            title: 'title',
            isError: false,
        }, 
        alertData: {
            isOpen: false, 
            message: '', 
            isError: false,
            interVal: null,
        }
    },
    mutations: {
        closeAlert(state) {
            if(state.alertData.interVal) {
                clearInterval(state.alertData.interVal);
                state.alertData.interVal = null;
            }
            state.alertData.interVal = setTimeout(()=> {
                state.alertData.isOpen = false
            }, 2500)
        },
        openAlert(state, { message, isError}) {
            console.log('isError:', isError,);
            state.alertData = {
                message: message, 
                isError: isError, 
                isOpen: true
            };
        },
        createUser(state, obj) {
            Cookie.set('user', JSON.stringify(obj), 30,);
            console.log('Set cookie user:', obj,);
            console.log('state.user:', state.user,);
            state.user = obj;
        },
        deleteUser(state) {
            Cookie.del('user');
            state.user = {
                role: { key: -1, },
            };
        },
        modalShow(state, { messages, title, isError, callback = null }) {
            state.modalData = {
                showModal: true,
                messages: messages,
                title: title,
                isError: isError,
            }
            if (callback != null) {
                callback();
            }
        },
        modalClose(state) {
            state.modalData = {
                showModal: false,
                messages: [],
                title: '',
                isError: false,
            }
        }
    },
    actions: {
        openModal(store, { messages, title, isError, callback = null }) {
            store.commit('modalShow', { messages, title, isError, callback });
        },
        toggleAlert(store, {message, isError}) {
            store.commit('openAlert', {message, isError});
            store.commit('closeAlert', {message, isError});
        },
    }
})